import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';

// requiredRole="ADMIN": quem não for admin volta para Agendamentos.
// (A API também bloqueia; isto só evita mostrar uma tela que não funcionaria.)
const PrivateRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) return <Navigate to="/" replace />;
  if (requiredRole && user !== requiredRole) return <Navigate to="/Agendamentos" replace />;

  return children;
};

export default PrivateRoute;
